import { Grid } from '@mui/material';
import Box from '@mui/material/Box';
import FormHeading from 'common/FormHeading';
import FormInputLabel from 'common/FormInputLabel';
import FormSelectInput from 'common/FormSelectInput';
import FormTextAreaInput from 'common/FormTextAreaInput';
import FormTextInput from 'common/FormTextInput';
import ImageUploader from 'common/ImageUploader/ImageUploader';
import { genderOptions } from 'common/constant';
import BoardCertification from 'pages/Business/Provider/ProviderPopup/Partials/BoardCertification';
import Education from 'pages/Business/Provider/ProviderPopup/Partials/Education';
import License from 'pages/Business/Provider/ProviderPopup/Partials/License';
import styled from 'styled-components';


import { useEffect, useState } from 'react';

import Specialty from './Specialty';

export default function ProfileForm({
    formData,
    formState,
    setFormData,
    handleChange,
    setAdditionalMultipleFields,
    additionalMultipleFields,
    error,
}) {
    const [extraQualificationCount, setExtraQualificationCount] = useState(0);
    const [extraSpecialtyCount, setExtraSpecialtyCount] = useState(0);
    const [extraLicenseCount, setExtraLicenseCount] = useState(0);
    const [extraBoardCertificationCount, setExtraBoardCertificationCount] = useState(0);
    const [extraEducationCount, setExtraEducationCount] = useState(0);

    const [extraQualification, setExtraQualification] = useState([]);

    const [extraSpecialty, setExtraSpecialty] = useState([]);
    const [extraSpecialtyCategory, setExtraSpecialtyCategory] = useState([]);

    const [extraLicenseNumber, setExtraLicenseNumber] = useState([]);
    const [extraLicenseState, setExtraLicenseState] = useState([]);
    const [extraLicenseYear, setExtraLicenseYear] = useState([]);

    const [extraBoardCertification, setExtraBoardCertification] = useState([]);
    const [extraBoardCertificationState, setExtraBoardCertificationState] = useState([]);
    const [extraBoardCertificationYear, setExtraBoardCertificationYear] = useState([]);

    const [extraEducationInstitute, setExtraEducationInstitute] = useState([]);
    const [extraEducationField, setExtraEducationField] = useState([]);
    const [extraEducationDegree, setExtraEducationDegree] = useState([]);


    const handelQualificationChange = (index) => {
        return (e) => {
            e.preventDefault();
            let { name, value } = e.target;
            let qualifications = extraQualification;
            qualifications[index] = value;
            setExtraQualification(qualifications);

            setAdditionalMultipleFields({
                ...additionalMultipleFields,
                qualification_title: qualifications,
            });
        };
    };

    const handelSpecialtyChange = (event, index) => {
        let { name, value } = event.target;

        //category
        if (name === 'specialty_category') {
            let categories = extraSpecialtyCategory;
 
            categories[index] = value;
            setExtraSpecialtyCategory(categories);

            setAdditionalMultipleFields({
                ...additionalMultipleFields,
                categories: categories,
            });
        }
        //title
        if (name === 'specialty_name') {
            let specialties = extraSpecialty;
            specialties[index] = value;
            setExtraSpecialty(specialties);

            setAdditionalMultipleFields({
                ...additionalMultipleFields,
                speciality: specialties,
            });
        }
    };
 

    const handelLicenseChange = (index) => {
        return (e) => {
 

            let { name, value } = e.target;

            if (name === 'license_number') {
                const licenses = [...(extraLicenseNumber || [])];
                licenses[index] = value;
                if (!value) {
                    const licensesState = [...(extraLicenseState || [])];
                    licensesState[index] = '';
                    setExtraLicenseState(licensesState);

                    const licensesYears = [...(extraLicenseYear || [])];
                    licensesYears[index] = '';
                    setExtraLicenseYear(licensesYears);

                    setAdditionalMultipleFields({
                        ...additionalMultipleFields,
                        license_year: licensesYears,
                        license_state: licensesState,
                    });
                }

                setExtraLicenseNumber(licenses);

                setAdditionalMultipleFields({
                    ...additionalMultipleFields,
                    license_number: licenses,
                });
            }

            if (name === 'license_state') {
                const licenses = [...(extraLicenseState || [])];
                licenses[index] = value;

                setExtraLicenseState(licenses);

                setAdditionalMultipleFields({
                    ...additionalMultipleFields,
                    license_state: licenses,
                });
            }

            if (name === 'license_year') {
                if (!/^\d{0,4}$/.test(value)) {
                    return; // Prevent invalid input
                }
                const licenses = [...(extraLicenseYear || [])];
                licenses[index] = value;
                setExtraLicenseYear(licenses);

                setAdditionalMultipleFields({
                    ...additionalMultipleFields,
                    license_year: licenses,
                });
            }
        };
    };

    const handelBoardCertificationChange = (index) => {
        return (e) => {
            let { name, value } = e.target;

            if (name === 'board_certification') {
                const certifications = [...(extraBoardCertification || [])];
                certifications[index] = value;
                setExtraBoardCertification(certifications);

                setAdditionalMultipleFields({
                    ...additionalMultipleFields,
                    board_certification: certifications,
                });

                if (!value) {
                    const statesArray = [...(extraBoardCertificationState || [])];
                    statesArray[index] = '';
                    setExtraBoardCertificationState(statesArray);

                    const yearsArray = [...(extraBoardCertificationYear || [])];
                    yearsArray[index] = '';
                    setExtraBoardCertificationYear(yearsArray);

                    setAdditionalMultipleFields({
                        ...additionalMultipleFields,
                        board_certification_year: yearsArray,
                        board_certification_state: statesArray,
                    });
                }
            }

            if (name === 'board_certification_state') {
                const certifications = [...(extraBoardCertificationState || [])];
                certifications[index] = value;
                setExtraBoardCertificationState(certifications);

                setAdditionalMultipleFields({
                    ...additionalMultipleFields,
                    board_certification_state: certifications,
                });
            }

            if (name === 'board_certification_year') {
                if (!/^\d{0,4}$/.test(value)) {
                    return; // Prevent invalid input
                }
                const certifications = [...(extraBoardCertificationYear || [])];
                certifications[index] = value;
                setExtraBoardCertificationYear(certifications);

                setAdditionalMultipleFields({
                    ...additionalMultipleFields,
                    board_certification_year: certifications,
                });
            }
        };
    };

    const handelEducationChange = (index) => {
        return (e) => {
            let { name, value } = e.target;

            if (name === 'education_institute') {
                let institutes = extraEducationInstitute;
                institutes[index] = value;
                setExtraEducationInstitute(institutes);

                setAdditionalMultipleFields({
                    ...additionalMultipleFields,
                    education_institute: institutes,
                });

                if (!value) {
                    let fields = extraEducationField;
                    fields[index] = '';
                    setExtraEducationField(fields);
                    setAdditionalMultipleFields({
                        ...additionalMultipleFields,
                        education_field: fields,
                    });
                }
            }

            if (name === 'education_field') {
                let fields = extraEducationField;
                fields[index] = value;
                setExtraEducationField(fields);

                setAdditionalMultipleFields({
                    ...additionalMultipleFields,
                    education_field: fields,
                });
            }

            if (name === 'education_degree') {
                let degrees = extraEducationDegree;
                degrees[index] = value;
                setExtraEducationDegree(degrees);

                setAdditionalMultipleFields({
                    ...additionalMultipleFields,
                    education_degree: degrees,
                });
            }
        };
    };

    useEffect(() => {
        setAdditionalMultipleFields({
            ...additionalMultipleFields,
            form_section: 'profile',
        });
    }, []);

    useEffect(() => {
        if (formState === 'edit') {
            let qualificationTitle = formData?.qualifications;
            setExtraQualificationCount(qualificationTitle?.length - 1);
            setExtraQualification(qualificationTitle);

            let specialty = formData?.specialties?.length > 0 ? formData?.specialties : formData?.speciality;
            const categoriesCount = formData?.categories?.length === 0 ? 0 : formData?.categories?.length - 1;
            setExtraSpecialtyCount(categoriesCount);
            setExtraSpecialty(specialty);
            setExtraSpecialtyCategory(formData?.categories);

            const licenseNumber = formData?.license_number;
            const licenseState = formData?.license_state;
            const licenseYear = formData?.license_year;
            setExtraLicenseCount(licenseNumber?.length - 1);
            setExtraLicenseNumber(licenseNumber);
            setExtraLicenseState(licenseState);
            setExtraLicenseYear(licenseYear);

            let boardCertification = formData?.board_certification;
            let boardCertificationState = formData?.board_certification_state;
            let boardCertificationYear = formData?.board_certification_year;
            setExtraBoardCertificationCount(boardCertification?.length - 1);
            setExtraBoardCertification(boardCertification);
            setExtraBoardCertificationState(boardCertificationState);
            setExtraBoardCertificationYear(boardCertificationYear);

            let educationInstitute = formData?.education_institute;
            let educationField = formData?.education_field;
            let educationDegree = formData?.education_degree;

            let educationsCount = 0;
            if (educationDegree?.length >= educationInstitute?.length) {
                if (educationDegree?.length === 0) {
                    educationsCount = 0;
                } else {
                    educationsCount = educationDegree?.length - 1;
                }
            } else {
                if (educationInstitute?.length === 0) {
                    educationsCount = 0;
                } else {
                    educationsCount = educationInstitute?.length - 1;
                }
            }
            setExtraEducationCount(educationsCount);
            setExtraEducationInstitute(educationInstitute);
            setExtraEducationField(educationField);
            setExtraEducationDegree(educationDegree);
        }
    }, [formData]);

    return (
        <>
            <Grid item xs={12}>
                <FormHeading>Provider Details</FormHeading>
            </Grid>
            <Grid item xs={12}>
                <FormInputLabel label="Provider Photo" required={true} />
            </Grid>
            <ImageUploader formData={formData} setFormData={setFormData} />
            {error && <div className={'text-red-500 mb-2 pl-4'}>{error}</div>}

            <FormTextInput
                formData={formData}
                label="Name"
                name="first_name"
                handleChange={handleChange}
                placeholder="Enter provider’s first name"
                required={true}
                labelSize={12}
                textSize={6}
            />

            <FormTextInput
                formData={formData}
                label="Last Name"
                name="last_name"
                handleChange={handleChange}
                placeholder="Enter provider's last name"
                required={true}
                noLabel={true}
                labelSize={12}
                textSize={6}
            />

            <FormTextInput
                formData={formData}
                label="Profile URL"
                name="profile_url"
                handleChange={handleChange}
                placeholder="Enter profile URL"
                required={true}
                labelSize={12}
                textSize={12}
                inputProps={{ autoComplete: 'off' }}
                helperText={"This is the direct link to a provider's profile that patients can view. The provider's name is added automatically, but you can customize it if you'd like."}
                InputProps={{
                            startAdornment: (
                                <Box
                                    className={
                                        '-ml-3.5 p-3 text-right text-sm '
                                    }
                                    sx={{
                                        backgroundColor: 'rgba(203, 193, 183, 1)',
                                        color: 'rgba(87, 83, 78, 1)',
                                        fontWeight: '500',
                                        borderTopLeftRadius: '7px',
                                        borderBottomLeftRadius: '7px',
                                    }}
                                >
                                    {process.env.REACT_APP_PATIENT_PORTAL_URL}/
                                </Box>
                            ),
                    sx: {
                        '& input': {
                            borderTopLeftRadius: '0px',
                            borderBottomLeftRadius: '0px',
                        },
                        '& input:hover': {
                            borderTopLeftRadius: '0px',
                            borderBottomLeftRadius: '0px',
                        },
                        '& input:focus': {
                            borderTopLeftRadius: '0px',
                            borderBottomLeftRadius: '0px',
                        },
                        '& input:focus-visible': {
                            borderTopLeftRadius: '0px',
                            borderBottomLeftRadius: '0px',
                        },
                        '& input:focus-within': {
                            borderTopLeftRadius: '0px',
                            borderBottomLeftRadius: '0px',
                        },
                        '& fieldset': {
                            borderTopLeftRadius: '0px',
                            borderBottomLeftRadius: '0px',
                        },
                        '& fieldset:hover': {
                            borderTopLeftRadius: '0px',
                            borderBottomLeftRadius: '0px',
                        },
                        '& fieldset:focus': {
                            borderTopLeftRadius: '0px',
                            borderBottomLeftRadius: '0px',
                        },
                    }
                }}
            />

            <FormTextInput
                formData={formData}
                label="Email"
                name="email"
                handleChange={handleChange}
                placeholder="Enter provider's email"
                required={true}
                labelSize={12}
                textSize={12}
                helperText={"This isn't shown to patients, it's only used to sent an invite link to join."}
            />

            <FormSelectInput
                label={'Gender'}
                name={'gender'}
                handleChange={handleChange}
                required={true}
                options={genderOptions}
                optionKey={'id'}
                optionValue={['value']}
                value={formData.gender}
                labelSize={12}
                inputSize={12}
                placeholder={'Select an gender'}
            />

            <FormTextAreaInput
                label={'About Bio'}
                name={'bio'}
                value={formData.bio}
                labelSize={12}
                textSize={12}
                handleChange={handleChange}
                placeholder={
                    'Ex: "Dr. Valletta is dedicated to providing the highest quality of orthopaedic care. In addition to tre... "'
                }
                helperText={'Give patients an overview about your provider.'}
                style={{ marginBottom: '44px' }}
            />

            <Grid item xs={12}>
                <FormHeading>Professional Credentials</FormHeading>
            </Grid>
            <FormInputLabel 
                label="Qualification Title" 
                labelSize={12}
                required={true}
                actionLink={
                    <Box
                        className={'primary-link'}
                        onClick={() => {
                            setExtraQualificationCount(extraQualificationCount + 1);
                        }}
                    >
                        + Add Another Title
                    </Box>
                }
            />
            <FormTextInput
                formData={formData}
                name="qualification_title"
                value={extraQualification?.[0]}
                handleChange={handelQualificationChange(0)}
                placeholder="Enter provider's qualification title"
                required={false}
                labelSize={12}
                textSize={12}
                helperText={'Ex. PhD, DO, MD, Etc.'}
                noLabel={true}
                additionAction={
                    extraQualificationCount > 0 && (
                        <Box
                            className={'danger-link float-end'}
                            onClick={() => {
                                setExtraQualificationCount(extraQualificationCount - 1);
                                const updatedQualifications = extraQualification.filter((_, i) => i !== 0);
                                setExtraQualification(updatedQualifications);
                                setAdditionalMultipleFields({
                                    ...additionalMultipleFields,
                                    qualification_title: updatedQualifications,
                                });
                            }}
                        >
                            - Remove This Title
                        </Box>
                    )
                }
            />
            {Array.from({ length: extraQualificationCount }).map((_, index) => (
                // <ExtraQualificationField key={index} index={index + 1} />
                <FormTextInput
                    noLabel={true}
                    label="Other Qualification Title"
                    name="qualification_title"
                    value={extraQualification[index + 1]}
                    handleChange={handelQualificationChange(index + 1)}
                    placeholder="Enter provider's qualification title"
                    required={false}
                    labelSize={12}
                    textSize={12}
                    additionAction={
                        extraQualificationCount > 0 && (
                            <Box
                                className={'danger-link float-end'}
                                onClick={() => {
                                    setExtraQualificationCount(extraQualificationCount - 1);
                                    const updatedQualifications = extraQualification.filter((_, i) => i !== index + 1);
                                    setExtraQualification(updatedQualifications);
                                    setAdditionalMultipleFields({
                                        ...additionalMultipleFields,
                                        qualification_title: updatedQualifications,
                                    });
                                }}
                            >
                                - Remove This Title
                            </Box>
                        )
                    }
                />
            ))}

            <FormInputLabel 
                label={'Specialty'} 
                labelSize={12}
                required={true}
                actionLink={
                    <Box
                        className={'primary-link'}
                        onClick={() => {
                            setExtraSpecialtyCount(extraSpecialtyCount + 1);
                        }}
                    >
                        + Add Another Specialty
                    </Box>
                }
            />
            <Specialty
                count={0}
                handleChange={handelSpecialtyChange}
                extraSpecialty={extraSpecialty}
                extraSpecialtyCategory={extraSpecialtyCategory}
            />
            {extraSpecialtyCount > 0 && (
                <Grid xs={12} item style={{marginTop: '0px', marginBottom: '20px'}}>
                    <Box
                        className={'danger-link float-end'}
                        onClick={() => {
                            setExtraSpecialtyCount(extraSpecialtyCount - 1);
                            const specialties = extraSpecialty.filter((_, i) => i !== 0);
                            const categories = extraSpecialtyCategory.filter((_, i) => i !== 0);
                            setExtraSpecialty(specialties);
                            setExtraSpecialtyCategory(categories);
                            setAdditionalMultipleFields({
                                ...additionalMultipleFields,
                                speciality: specialties,
                                categories: categories,
                            });
                        }}
                    >
                        - Remove This Specialty
                    </Box>
                </Grid>
            )}
            {Array.from({ length: extraSpecialtyCount }).map((_, index) => (
                <>
                    <Specialty
                        count={index + 1}
                        key={index}
                        handleChange={handelSpecialtyChange}
                        extraSpecialty={extraSpecialty}
                        extraSpecialtyCategory={extraSpecialtyCategory}
                    />
                        {extraSpecialtyCount > 0 && (
                            <Grid xs={12} item style={{marginTop: '0px', marginBottom: '20px'}}>
                                <Box
                                    className={'danger-link float-end'}
                                    onClick={() => {
                                        setExtraSpecialtyCount(extraSpecialtyCount - 1);
                                        const specialties = extraSpecialty.filter((_, i) => i !== index + 1);
                                        const categories = extraSpecialtyCategory.filter((_, i) => i !== index + 1);
                                        setExtraSpecialty(specialties);
                                        setExtraSpecialtyCategory(categories);
                                        setAdditionalMultipleFields({
                                            ...additionalMultipleFields,
                                            speciality: specialties,
                                            categories: categories,
                                        });
                                    }}
                                >
                                    - Remove This Specialty
                                </Box>
                            </Grid>
                        )}
                </>
            ))}

            <Grid item xs={12} style={{ marginTop: '18px' }}>
                <FormInputLabel 
                    label={'License'} 
                    labelSize={12}
                    required={true}
                    actionLink={
                        <Box
                            className={'primary-link'}
                            style={{marginTop: '0px', marginBottom: '0'}}
                            onClick={() => {
                                setExtraLicenseCount(extraLicenseCount + 1);
                            }}
                        >
                            + Add Another License
                        </Box>
                    }
                />
            </Grid>
            <License
                count={0}
                formData={formData}
                handleChange={handelLicenseChange(0)}
                extraLicenseNumber={extraLicenseNumber}
                extraLicenseState={extraLicenseState}
                extraLicenseYear={extraLicenseYear}
            />
            {extraLicenseCount > 0 && (
                <Grid xs={12} item style={{marginTop: '0px', marginBottom: '20px'}}>
                    <Box
                        className={'danger-link float-end'}
                        onClick={() => {
                            setExtraLicenseCount(extraLicenseCount - 1);
                            const licensesNumbers = extraLicenseNumber?.filter((_, i) => i !== 0);
                            const licensesStates = extraLicenseState?.filter((_, i) => i !== 0);
                            const licensesYears = extraLicenseYear?.filter((_, i) => i !== 0);

                            setExtraLicenseState(licensesStates);
                            setExtraLicenseNumber(licensesNumbers);
                            setExtraLicenseYear(licensesYears);

                            setAdditionalMultipleFields({
                                ...additionalMultipleFields,
                                license_number: licensesNumbers,
                                license_state: licensesStates,
                                license_year: licensesYears,
                            });
                        }}
                    >
                        - Remove This License
                    </Box>
                </Grid>
            )}
            {Array.from({ length: extraLicenseCount }).map((_, index) => (
                <>
                    <License
                        count={index + 1}
                        key={index}
                        formData={formData}
                        handleChange={handelLicenseChange(index + 1)}
                        extraLicenseNumber={extraLicenseNumber}
                        extraLicenseState={extraLicenseState}
                        extraLicenseYear={extraLicenseYear}
                    />
                    {extraLicenseCount > 0 && (
                        <Grid xs={12} item style={{marginTop: '0px', marginBottom: '20px'}}>
                            <Box
                                className={'danger-link float-end'}
                                onClick={() => {
                                    setExtraLicenseCount(extraLicenseCount - 1);
                                    const licensesNumbers = extraLicenseNumber?.filter((_, i) => i !== index + 1);
                                    const licensesStates = extraLicenseState?.filter((_, i) => i !== index + 1);
                                    const licensesYears = extraLicenseYear?.filter((_, i) => i !== index + 1);

                                    setExtraLicenseState(licensesStates);
                                    setExtraLicenseNumber(licensesNumbers);
                                    setExtraLicenseYear(licensesYears);

                                    setAdditionalMultipleFields({
                                        ...additionalMultipleFields,
                                        license_number: licensesNumbers,
                                        license_state: licensesStates,
                                        license_year: licensesYears,
                                    });
                                }}
                            >
                                - Remove This License
                            </Box>
                        </Grid>
                    )}
                </>
            ))}

            <Grid item xs={12} style={{ marginTop: '18px' }}>
                <FormInputLabel 
                    label={'Board Certification'} 
                    labelSize={12}
                    required={true}
                    actionLink={
                        <Box
                            className={'primary-link'}
                            style={{marginTop: '0px', marginBottom: '0'}}
                            onClick={() => {
                                setExtraBoardCertificationCount(extraBoardCertificationCount + 1);
                            }}
                        >
                            + Add Another Certification
                        </Box>
                    }
                />
            </Grid>
            <BoardCertification
                count={0}
                formData={formData}
                handleChange={handelBoardCertificationChange(0)}
                extraBoardCertification={extraBoardCertification}
                extraBoardCertificationState={extraBoardCertificationState}
                extraBoardCertificationYear={extraBoardCertificationYear}
            />
            {extraBoardCertificationCount > 0 && (
                <Grid xs={12} item style={{marginTop: '0px', marginBottom: '20px'}}>
                    <Box
                        className={'danger-link float-end'}
                        onClick={() => {
                            setExtraBoardCertificationCount(extraBoardCertificationCount - 1);

                            const certification = extraBoardCertification?.filter((_, i) => i !== 0);
                            const state = extraBoardCertificationState?.filter((_, i) => i !== 0);
                            const year = extraBoardCertificationYear?.filter((_, i) => i !== 0);

                            setExtraBoardCertification(certification);
                            setExtraBoardCertificationState(state);
                            setExtraBoardCertificationYear(year);

                            setAdditionalMultipleFields({
                                ...additionalMultipleFields,
                                board_certification: certification,
                                board_certification_state: state,
                                board_certification_year: year,
                            });
                        }}
                    >
                        - Remove This Certification
                    </Box>
                </Grid>
            )}
            {Array.from({ length: extraBoardCertificationCount }).map((_, index) => (
                <>
                    <BoardCertification
                        count={index + 1}
                        key={index}
                        formData={formData}
                        handleChange={handelBoardCertificationChange(index + 1)}
                        extraBoardCertification={extraBoardCertification}
                        extraBoardCertificationState={extraBoardCertificationState}
                        extraBoardCertificationYear={extraBoardCertificationYear}
                    />
                    {extraBoardCertificationCount > 0 && (
                        <Grid xs={12} item style={{marginTop: '0px', marginBottom: '20px'}}>
                            <Box
                                className={'danger-link float-end'}
                                onClick={() => {
                                    setExtraBoardCertificationCount(extraBoardCertificationCount - 1);

                                    const certification = extraBoardCertification?.filter((_, i) => i !== index + 1);
                                    const state = extraBoardCertificationState?.filter((_, i) => i !== index + 1);
                                    const year = extraBoardCertificationYear?.filter((_, i) => i !== index + 1);

                                    setExtraBoardCertification(certification);
                                    setExtraBoardCertificationState(state);
                                    setExtraBoardCertificationYear(year);

                                    setAdditionalMultipleFields({
                                        ...additionalMultipleFields,
                                        board_certification: certification,
                                        board_certification_state: state,
                                        board_certification_year: year,
                                    });
                                }}
                            >
                                - Remove This Certification
                            </Box>
                        </Grid>
                    )}
                </>
            ))}

            <Grid item xs={12} style={{ marginTop: '18px' }}>
                <FormInputLabel 
                    label={'Education'} 
                    labelSize={12}
                    actionLink={
                        <Box
                            className={'primary-link'}
                            style={{marginTop: '0px', marginBottom: '0'}}
                            onClick={() => {
                                setExtraEducationCount(extraEducationCount + 1);
                            }}
                        >
                            + Add Another Education
                        </Box>
                    }
                />
            </Grid>
            <Education
                count={0}
                formData={formData}
                handleChange={handelEducationChange(0)}
                extraEducationInstitute={extraEducationInstitute}
                extraEducationField={extraEducationField}
                extraEducationDegree={extraEducationDegree}
            />
            {extraEducationCount > 0 && (
                <Grid xs={12} item style={{marginTop: '0px', marginBottom: '20px'}}>
                    <Box
                        className={'danger-link float-end'}
                        onClick={() => {
                            setExtraEducationCount(extraEducationCount - 1);

                            const institute = extraEducationInstitute.filter((_, i) => i !== 0);
                            const field = extraEducationField.filter((_, i) => i !== 0);
                            const degree = extraEducationDegree.filter((_, i) => i !== 0);

                            setExtraEducationInstitute(institute);
                            setExtraEducationField(field);
                            setExtraEducationDegree(degree);

                            setAdditionalMultipleFields({
                                ...additionalMultipleFields,
                                education_institute: institute,
                                education_field: field,
                                education_degree: degree,
                            });
                        }}
                    >
                        - Remove This Education
                    </Box>
                </Grid>
            )}
            {Array.from({ length: extraEducationCount }).map((_, index) => (
                <>
                    <Education
                        count={index + 1}
                        key={index}
                        formData={formData}
                        handleChange={handelEducationChange(index + 1)}
                        extraEducationInstitute={extraEducationInstitute}
                        extraEducationField={extraEducationField}
                        extraEducationDegree={extraEducationDegree}
                    />
                    {extraEducationCount > 0 && (
                        <Grid xs={12} item style={{marginTop: '0px', marginBottom: '20px'}}>
                            <Box
                                className={'danger-link float-end'}
                                onClick={() => {
                                    setExtraEducationCount(extraEducationCount - 1);

                                    const institute = extraEducationInstitute.filter((_, i) => i !== index + 1);
                                    const field = extraEducationField.filter((_, i) => i !== index + 1);
                                    const degree = extraEducationDegree.filter((_, i) => i !== index + 1);

                                    setExtraEducationInstitute(institute);
                                    setExtraEducationField(field);
                                    setExtraEducationDegree(degree);

                                    setAdditionalMultipleFields({
                                        ...additionalMultipleFields,
                                        education_institute: institute,
                                        education_field: field,
                                        education_degree: degree,
                                    });
                                }}
                            >
                                - Remove This Education
                            </Box>
                        </Grid>
                    )}
                </>
            ))}

        </>
    );
}
